"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This is a function that creates a proxy to check if a variables is being used
 * Useful to detect global variable usage
 * @param obj Any object
 * @param msg A message
 */
function proxySpy(obj, msg) {
    return new Proxy(obj, {
        get(target, name) {
            console.error(`${msg}: GET HERE!!!!`);
            return target[name];
        },
        construct(target, args) {
            console.error(`${msg}: CONSTRUCTOR HERE!!!!`);
            return new target(args);
        },
        apply(target, that, args) {
            console.error(`${msg}: FUCTION HERE!!!!`);
            return target.apply(that, args);
        }
    });
}
exports.default = proxySpy;
